import { gql } from '@apollo/client';

export const UPDATE_PROJECT = gql`
  mutation UpdateProject($id: ID!, $attributes: ProjectAttributes!) {
    updateProject(id: $id, attributes: $attributes) {
      project {
        id
        name
        description
      }
    }
  }
`;

export const CREATE_PREVIEW_STUDY = gql`
  mutation CreateCardSortPreviewStudy($projectId: ID!) {
    createCardSortPreviewStudy(projectId: $projectId) {
      testSession {
        id
        isPreview
      }
    }
  }
`;
